import { useState } from 'react';

export function useEditTranslateController() {
  const [isEditing, setIsEditing] = useState<string>();

  return { isEditing, setIsEditing };
}
